import React from 'react';
import { Row, Col, Card } from 'antd';
// import { UnorderedListOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import qs from 'query-string';

import SectionTitle from 'src/components/layout/SectionTitle';
import useProductCategory from 'src/queries/useProductCategory';
import history from 'src/libs/history';
import { PATH } from 'src/pages/pricing';
import productPortfolioImage from 'src/assets/images/img-product-portfilio.png';

const { Meta } = Card;

const ProductPortfolio: React.FC = () => {
  const { t } = useTranslation();
  const { trimNameCategories } = useProductCategory();

  const onSelectCategory = (varietyId, shapeId) => {
    history.push({
      pathname: PATH,
      search: qs.stringify({
        hinshL3Cd: varietyId,
        keijoL3Cd: shapeId,
      }),
    });
  };

  return (
    <>
      <SectionTitle
        title={t('top_page.ProductPortfolio.item_category')}
        // icon={<UnorderedListOutlined />}
      />
      <Row gutter={[16, 16]} className="product_portfolio_section">
        {trimNameCategories?.map((item) => (
          <Col xs={24} sm={12} md={8} lg={6} key={item.categoryId}>
            <Card
              hoverable
              style={{ width: '100%' }}
              bodyStyle={{ padding: 0 }}
            >
              <div className="product_card">
                <div
                  className="product_card_header"
                  style={{
                    backgroundImage: `url(${productPortfolioImage})`,
                  }}
                ></div>
                <div className="product_card_overlay">{item.categoryName}</div>
              </div>
              <Meta
                className="product_card_meta"
                title={
                  <ul className="product_meta_list">
                    {item.childrenList?.map((child) => (
                      <li
                        key={child.categoryId}
                        onClick={() =>
                          onSelectCategory(item?.categoryId, child?.categoryId)
                        }
                      >
                        {child.categoryName}
                      </li>
                    ))}
                  </ul>
                }
              />
            </Card>
          </Col>
        ))}
      </Row>
    </>
  );
};

export default ProductPortfolio;
